import { render, staticRenderFns } from "./ProductionOrderSelect.vue?vue&type=template&id=56724f5e&scoped=true&"
import script from "./ProductionOrderSelect.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56724f5e",
  null
  
)

export default component.exports